import CardClinicalHistory from "./components/CardClinicalHistory";
import { Skeleton, Stack } from "@mui/material";

const ListClinicalHistory = ({ clinicalHistory, loading }) => {
  return (
    <Stack spacing={2}>
      {loading ? (
        <Stack spacing={2}>
          <Skeleton animation="wave" variant="rounded" height={200} />
          <Skeleton animation="wave" variant="rounded" height={200} />
          <Skeleton animation="wave" variant="rounded" height={200} />
        </Stack>
      ) : (
        clinicalHistory.map((history, index) => (
          <CardClinicalHistory key={index} history={history} />
        ))
      )}
    </Stack>
  );
};

export default ListClinicalHistory;
